import {NgModule} from '@angular/core';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {ShareModule} from '../../share/share.module';
import {ZoneUtilisateurComponent} from './zone-utilisateur.component';
import {MatLegacyRadioModule as MatRadioModule} from '@angular/material/legacy-radio';

@NgModule({
  declarations: [
    ZoneUtilisateurComponent
  ],
  imports: [
    ShareModule,
    MatCheckboxModule,
    MatRadioModule
  ],
  exports: [
    ZoneUtilisateurComponent
  ]
})
export class ZoneUtilisateurModule { }
